import { Trans } from '@lingui/react'

import { useSubmitCashCompletedMutation } from '@twisto/api-graphql'
import { AlertDialogContent } from '@twisto/components/atoms/alert-dialog'
import { TextButton } from '@twisto/components/atoms/button'
import {
  Headline,
  HeadlineIcon,
  HeadlineSubtitle,
  HeadlineTitle,
} from '@twisto/components/atoms/headline'
import { BigTickIcon } from '@twisto/icons'

import { useFlow } from '../../flow/flow.context'

import * as styles from './cash-completed-step.styles'

export const CashCompletedStep = () => {
  const { sessionId } = useFlow()
  const [submitCashCompleted, { loading }] = useSubmitCashCompletedMutation()

  const handleContinue = () => {
    submitCashCompleted({
      variables: {
        auth: {
          sessionId,
        },
      },
    })
  }

  return (
    <>
      <Headline>
        <HeadlineIcon>
          <BigTickIcon color="primary" height="100%" width="100%" />
        </HeadlineIcon>
        <HeadlineTitle>
          <Trans id="flow.cashCompletedStep.title" />
        </HeadlineTitle>
        <HeadlineSubtitle>
          <Trans id="flow.cashCompletedStep.subtitle" />
        </HeadlineSubtitle>
      </Headline>
      <TextButton
        fullWidth
        css={styles.button}
        disabled={loading}
        onClick={handleContinue}
      >
        <Trans id="flow.cashCompletedStep.continueButton" />
      </TextButton>
    </>
  )
}
